let authEndPoint;
const stagingURL = 'https://pkw-test.viscomp.net/api/v1';
const reviewAppURL = 'https://pkwde-pr-2612.herokuapp.com/api/v1'
const isProduction = process.env.VUE_APP_ENV === 'production';

if (isProduction) {
  authEndPoint = process.env.VUE_APP_API_URL
    ? `${process.env.VUE_APP_API_URL}/api/v1`
    : 'https://www.pkw.de/api/v1';
} else {
  authEndPoint = stagingURL;
}

export default {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  authEndPoint,
};
